div#description-container {
  padding: calc(4 * var(--spacer)) 0 0 calc(5 * var(--spacer));
}

div#child-groups-grid gz-title {
  padding: calc(1 * var(--spacer)) 0 0 calc(5 * var(--spacer));
}

div#targets-grid gz-title {
  padding: calc(1 * var(--spacer)) 0 0 calc(5 * var(--spacer));
}

gz-text#force-inheritance-text-info {
  width: 70%;
}

div#extra-info-custom-assignation {
  > * {
    margin-top: calc(1 * var(--spacer));
  }
}

#master-policy-filter {
  width: 560px;
}

gz-radio-group > gz-radio {
  margin-top: calc(4 * var(--spacer));
  width: fit-content;
}

gz-checkbox {
  width: fit-content;
}

.disabled,
gz-radio-group[disabled] {
  opacity: 0.6;
  pointer-events: none;

  #child-groups-form-field {
    opacity: 0.6;
  }
}

div#cannot-apply-changes-container {
  display: flex;
  align-items: center;
}

gz-info-box::part(container) {
  width: 560px;
}

gz-info-box {
  width: 560px;
  padding: 0 0 0 0;
}

.child-groups-grid {
  margin-bottom: calc(var(--spacer) * 5);
}

.child-groups-grid,
.targets-grid {
  gz-title {
    margin-bottom: var(--spacer);
  }
}

gz-radio[name='assignation-group'] {
  margin-bottom: calc(var(--spacer) * 2);
  position: relative;
  z-index: 1;
}

gz-single-select-complex {
  --dropdown-list-width: 320px;
}
